import { useMemo } from 'react';
import { useOpts } from '../../context';
import { WORKSPACE_TO_ROUTING_NOS_MAPPING, WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING_PREFILLED_FIELD, } from '../../consts/routing-number-mappings';
function useRoutingNumberField() {
    var workspaceName = useOpts().linkTokenPayload.workspaceName;
    var routingNumberField = useMemo(function () {
        if (workspaceName in WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING_PREFILLED_FIELD) {
            var textRoutingNumberField = {
                fieldType: 'text',
                fieldSubtype: 'plaintext',
                key: 'routingNumber',
                label: 'Routing number',
                pattern: '[0-9]{9}',
                initialValue: WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING_PREFILLED_FIELD[workspaceName],
            };
            return textRoutingNumberField;
        }
        if (!(workspaceName in WORKSPACE_TO_ROUTING_NOS_MAPPING)) {
            var textRoutingNumberField = {
                fieldType: 'text',
                fieldSubtype: 'plaintext',
                key: 'routingNumber',
                label: 'Routing number',
                pattern: '[0-9]{9}',
                required: true,
            };
            return textRoutingNumberField;
        }
        var routingNos = WORKSPACE_TO_ROUTING_NOS_MAPPING[workspaceName];
        var selectRoutingNumberField = {
            fieldType: 'select_single',
            key: 'routingNumber',
            label: 'Routing number',
            options: routingNos.map(function (_a) {
                var n = _a[0], state = _a[1];
                return ({
                    value: n,
                    label: "".concat(n, " (").concat(state, ")"),
                });
            }),
            required: true,
        };
        return selectRoutingNumberField;
    }, [workspaceName]);
    return routingNumberField;
}
export default useRoutingNumberField;
